import { IsBoolean, IsInt, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

export class NpsSurveyGetManyQueryDto {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  merchantGroupId: number;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  active: boolean;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  published: boolean;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  unassigned: boolean;
}
